

























import Vue from "vue";
import i18n from "@/locales/i18n";
import _ from "lodash";
import { allProvincial, subAreas } from "@/components/picker/area-data-for-vant";

const PROVINCIAL_COLUMN_INDEX = 0;
const CITY_COLUMN_INDEX = 1;
const DISTRICT_COLUMN_INDEX = 2;

function changePickerColumn(picker, columnIndex, columnValues) {
    picker.setColumnValues(columnIndex, columnValues);
    picker.setColumnIndex(columnIndex, 0);
}

function onProvincialChange(picker, provincial) {
    const cities = subAreas(provincial);
    const districts = subAreas(cities[0]);
    changePickerColumn(picker, CITY_COLUMN_INDEX, cities);
    changePickerColumn(picker, DISTRICT_COLUMN_INDEX, districts);
}

function onCityChange(picker, city) {
    const districts = subAreas(city);
    changePickerColumn(picker, DISTRICT_COLUMN_INDEX, districts);
}

export default Vue.extend({
    name: "AreaPicker",
    props: {
        value: Array,
        label: {
            type: String,
            required: true
        },
        placeholder: {
            type: String,
            default: i18n.t("common.placeholder.select")
        },
        rules: Array
    },
    data() {
        return {
            allArea: new Array(0),
            showPicker: false
        };
    },
    mounted() {
        if (this.value && this.value.length === 3) {
            const [provincial, city, district] = this.value;
            this.initArea(provincial, city);
            this.doSelectProvincial(provincial);
            this.doSelectCity(provincial, city);
            this.doSelectDistrict(city, district);
        } else {
            this.initArea();
        }
    },
    computed: {
        selectedText(): string {
            if (this.value && this.value.length === 3) {
                return _.map(this.value, "text").join("/");
            }
            return "";
        }
    },
    methods: {
        doSelectProvincial(provincial) {
            const index = this.findSelectedIndex(allProvincial(), provincial);
            this.doSelectColumn(PROVINCIAL_COLUMN_INDEX, index);
        },
        doSelectCity(provincial, city) {
            const index = this.findSelectedIndex(subAreas(provincial), city);
            this.doSelectColumn(CITY_COLUMN_INDEX, index);
        },
        doSelectDistrict(city, district) {
            const index = this.findSelectedIndex(subAreas(city), district);
            this.doSelectColumn(DISTRICT_COLUMN_INDEX, index);
        },
        doSelectColumn(columnIndex, selectedIndex) {
            this.allArea[columnIndex]["defaultIndex"] = selectedIndex;
        },
        findSelectedIndex(columnData, selectedArea): number {
            return _.findIndex(columnData, (area: object) => {
                return area["code"] === selectedArea["code"];
            });
        },
        initArea(provincial: any = null, city: any = null) {
            const provincials = allProvincial();
            const cities = subAreas(provincial ? provincial : provincials[0]);
            const districts = subAreas(city ? city : cities[0]);
            this.allArea = [{ values: provincials }, { values: cities }, { values: districts }];
        },
        onChange(picker, values, columnIndex) {
            const [provincial, city] = values;
            if (columnIndex === PROVINCIAL_COLUMN_INDEX) {
                onProvincialChange(picker, provincial);
            } else if (columnIndex === CITY_COLUMN_INDEX) {
                onCityChange(picker, city);
            }
        },
        onConfirm(values) {
            this.showPicker = false;
            this.$emit("input", values);
            this.$emit("blur", values);
            this.$emit("change", values);
        }
    }
});
